// extracted by mini-css-extract-plugin
export default {"ModalContainer":"IntegrationsModal_ModalContainer__sLWJA","WhatsPROIcon":"IntegrationsModal_WhatsPROIcon__ZUfDq","EcommerceIcon":"IntegrationsModal_EcommerceIcon__E7lOD"};